document.addEventListener("DOMContentLoaded", function () {
  const qtyWrappers = document.querySelectorAll(".quantity-selector");

  qtyWrappers.forEach(wrapper => {
    const input = wrapper.querySelector(".quantity-input");
    const minusBtn = wrapper.querySelector(".quantity-btn--minus");
    const plusBtn = wrapper.querySelector(".quantity-btn--plus");

    minusBtn.addEventListener("click", () => {
      let val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });

    plusBtn.addEventListener("click", () => {
      let val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });
});
